// extracted by mini-css-extract-plugin
export default {"playTable":"play-table_playTable__VT8R-","bodyTableContainer":"play-table_bodyTableContainer__yFSZ7","newPlayContainer":"play-table_newPlayContainer__5iCFX"};